<template>
  <Screen>
    <AppBar
      title="Blissdom sections"
      :showBackButton="false"
      description="Manage BIBO app blissdom tab sections"
    />
    <Breadcrumbs title="Blissdom sections" />
    <div class="list">
      <div class="item" v-for="item in data.data" :key="item.id">
        <div class="icon">
          <img
            v-lazy="item.icon || asset('images/blissdom/default.png')"
            alt=""
            height="100"
            width="100"
            class="img-fluid"
          />
        </div>
        <div class="title-wrapper">
          <div class="d-block">
            <span class="badge badge-success" v-if="item.isactive">
              Active
            </span>
            <span class="badge badge-danger" v-else> In-Active </span>
            <span class="badge badge-warning" v-if="item.premium_only">
              <small
                class="fas fa-crown"
                style="position: relative; top: -1px; margin-right: 1px"
              ></small>
              Premium content
            </span>
          </div>
          <p class="title mt-1 mb-0" v-text="item.name"></p>
        </div>
        <div class="mt-auto">
          <inertia-link
            :href="
              $route('admin.blissdom.sections.edit', {
                id: item.id,
              })
            "
            class="btn btn-light btn-block btn-sm"
          >
            <span>Edit</span>
            <small class="fa fa-arrow-right ml-1"></small>
          </inertia-link>
        </div>
        <div class="sort-number">#{{ item.sort_order }}</div>
      </div>
    </div>
  </Screen>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>
<style lang="scss" scoped>
.list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  grid-gap: 1rem;

  .item {
    padding: 1rem;
    border-radius: var(--border-radius);
    border: 2px solid var(--lighter);
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    position: relative;

    .sort-number {
      position: absolute;
      top: 1rem;
      right: 1rem;
      z-index: 0;
    }

    .icon img {
      height: 60px;
      max-height: 60px;
      width: auto;
    }

    .title-wrapper {
      .title {
        font-size: 1.1rem;
        font-weight: 600;
        color: var(--dark);
      }
    }

    .badge {
      font-size: 68%;
      padding: 0.25em 0.6em;
      font-size: 0.64rem;
      line-height: 1;
    }

    .btn {
      margin-top: 0.5rem;
      font-size: 0.92rem;
    }
  }
}
</style>